import React from 'react';

const ResultCount = ({ count }) => {

    const message = 'item' + (count > 1 ? 's' : '') + ' found';

    return (
        <div className="result-count">
            <span>{`${count} ${message}`}</span>
        </div>
    );
};

ResultCount.propTypes = {
    count: React.PropTypes.number.isRequired
};

export default ResultCount;



/** WEBPACK FOOTER **
 ** ./src/components/filtered-listing/items/result-count/ResultCount.jsx
 **/